"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdditionalViewControls = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const hooks_1 = require("../../hooks");
const ViewControls_1 = require("../../organisms/ViewControls");
const styled_components_1 = __importDefault(require("styled-components"));
function AdditionalViewControls({ onClick, }) {
    const { t } = (0, i18n_1.useTranslation)();
    const isLower = (0, ui_1.useScreenBreakpoint)(ui_1.sizeMainScreen.tablet);
    const infoboxControls = (0, hooks_1.useInfoBoxControlsState)();
    const { isActive: isMultiSelectActive } = (0, hooks_1.useMultiSelectState)();
    const onClickControls = (type) => {
        return () => {
            onClick(type);
        };
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'AdditionalViewControls_Container', children: [(0, jsx_runtime_1.jsx)(StyledButton, { onClick: onClickControls(ViewControls_1.ViewControlsType.HideOthers), isSelected: infoboxControls.hidingOthers == 1, disabled: infoboxControls.hidingOthers === -1, "data-e2e": 'AdditionalViewControls_StyledButton', children: t(i18n_1.Strings.infoBox.menu.hidingOthers) }), (0, jsx_runtime_1.jsx)(StyledButton, { onClick: onClickControls(ViewControls_1.ViewControlsType.FadeOthers), isSelected: infoboxControls.fadingOthers == 1, disabled: infoboxControls.fadingOthers === -1, "data-e2e": 'AdditionalViewControls_StyledButton', children: t(i18n_1.Strings.infoBox.menu.fadingOthers) }), !isLower && ((0, jsx_runtime_1.jsx)(StyledButton, { onClick: onClickControls(ViewControls_1.ViewControlsType.MultiSelect), isSelected: isMultiSelectActive, "data-e2e": 'AdditionalViewControls_StyledButton', children: t(i18n_1.Strings.infoBox.menu.multiSelect) }))] }));
}
exports.AdditionalViewControls = AdditionalViewControls;
const StyledButton = (0, styled_components_1.default)(ui_1.ToolBarBaseButton) `
  padding: 12px 14px 12px 14px;
  font-family: 'Elsevier Sans';
`;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;

  pointer-events: auto;
`;
exports.default = AdditionalViewControls;
